import { render, staticRenderFns } from "./ComplaintFilter.vue?vue&type=template&id=73695938"
import script from "./ComplaintFilter.vue?vue&type=script&lang=js"
export * from "./ComplaintFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports